import {Pipe, PipeTransform} from '@angular/core';

@Pipe({standalone: true, name: 'locationPipe'})
export class LocationPipe implements PipeTransform
{
  transform(item: any, withoutStreet?: boolean): string
  {
    if (item)
    {
      // const zip = item.zip ? item.zip : item.locationPostalCode;
      const zip = item.zip ?? item.locationPostalCode ?? item.postalCode;
      const city = item.city ? item.city : item.locationCity;
      const street = item.street ? item.street : item.locationStreet;

      if (!withoutStreet && zip && city && street)
        return street + ', ' + zip + ' ' + city;
      else if (zip && city)
        return zip + ' ' + city;
      else if (city)
        return city;
      else if (!withoutStreet && street)
        return street;
      else if (zip)
        return zip;
      else return '';
    }
    return '';
  }
}
